import Prompter from './prompter.vue';
import Vue from 'vue';

const defaults = Object.keys(Prompter.props).reduce((obj = {}, key) => {
  obj[key] = Prompter.props[key].default;
  return obj;
}, { value: false, content: null, onCancle: null, onConfirm: null, onUpdate: null });

const hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn(obj, key) {
  return hasOwnProperty.call(obj, key);
}
function isVNode(node) {
  return node !== null && typeof node === 'object' && hasOwn(node, 'componentOptions');
}

Prompter.newInstance = properties => {
  const props = properties ? { ...defaults, ...properties } : defaults;
  let el = props.el || '';
  const Instance = new Vue({
    data() {
      return props;
    },
    render(h) {
      return h(Prompter, {
        props: props,
        on: {
          onOpen() {
            Instance.onOpen && Instance.onOpen();
          },
          onClose() {
            Instance.onClose && Instance.onClose();
          },
          input: (val) => {
            Instance.value = val;
          }
        }
      });
    }
  });
  const component = Instance.$mount();

  if (el && document.querySelector(el)) {
    document.querySelector(el).appendChild(component.$el);
  } else {
    document.body.appendChild(component.$el);
  }

  const prompt = Instance.$children[0];
  return {
    state() {
      return Instance.value;
    },
    hide() {
      prompt.onHide();
    },
    show(options) {
      prompt.onShow(options);
    },
    updata(options) {
      Object.assign(Instance.$data, defaults, options);
      if (isVNode(Instance.content)) {
        prompt.$slots.default = Instance.content;
        prompt.content = null;
      } else {
        delete prompt.$slots.default;
        prompt.content = Instance.content;
      }
    },
    destroy() {
      Instance.$destroy();
    }
  };
};
export default Prompter;